// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-center-parent-container {
  width: 100%;
  max-width: 1100px;
}

.notification-center-info-box {
  display: flex;
  align-items: center;
  gap: 20px;
  background-color: #5616ea25;
  border-radius: 10px;
  padding: 15px;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-bottom: 20px;
  line-height: 1.45;
  border-left: 5px solid #5616ea;
}

.notification-center-info-content {
  display: flex;
  flex-direction: column;
}

.notification-center-info-box p {
  margin: 0;
  padding: 0;
}

.notification-center-info-content ul {
  margin: 0.5rem 0 0 0;
  padding-left: 1.2rem;
  list-style-type: disc;
}

.notification-center-info-content li {
  margin-top: 7px;
}

.notification-center-info-icon {
  font-size: 32px;
  color: #5616ea;
  flex-shrink: 0;
}

.notification-center-warning-inner {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #fff9e1;
  border-left: 4px solid #ffc107;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 16px;
}

.notification-center-warning-inner p {
  margin: 0;
  color: #554002;
  font-size: 14px;
}

.notification-center-warning-icon {
  font-size: 20px;
  color: #ffc107;
  flex-shrink: 0;
}

/* Visual indicator before each section title to make accordion sections more
   distinguishable from one another. */
.notification-section-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.notification-section-title-bar {
  display: inline-block;
  width: 4px;
  height: 18px;
  background-color: #5616ea;
  border-radius: 2px;
  flex-shrink: 0;
}

/* Apply the same purple accent bar to every accordion section header that uses
   the shared \`.widget-sub-header\` class (Design, Human Takeover, Lead
   Generation pages). Scoped to MUI AccordionSummary so non-accordion uses are
   unaffected. */
.MuiAccordionSummary-content .widget-sub-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.MuiAccordionSummary-content .widget-sub-header::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background-color: #5616ea;
  border-radius: 4px;
  flex-shrink: 0;
}

.notification-center-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 20px;
}

/* Subtle inline link used in liveChatSettings & warmLeadConfig to point users
   to the notification center. */
.notification-center-link {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 8px;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
  color: #5616ea;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: rgba(86, 22, 234, 0.4);
  text-underline-offset: 2px;
  transition: color 0.2s ease, text-decoration-color 0.2s ease;
  margin-bottom: 20px;
}

.notification-center-link:hover {
  color: #4a14d6;
  text-decoration-color: #4a14d6;
}

.notification-center-link-channels {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-left: -2px;
  color: #5616ea;
  opacity: 0.75;
  text-decoration: none;
  font-size: 10px;
}

.notification-center-link:hover .notification-center-link-channels {
  opacity: 1;
  color: #4a14d6;
}

/* Recipients section — sits below the matrix. The h4 sub-header above
   it provides the spacing to the matrix; the first recipient block must
   therefore not add its own top margin. */
.notification-recipients-block {
  margin-top: 16px;
}

.notification-recipients-block .notification-emails-section {
  margin-top: 0;
}

.notification-recipients-block .notification-emails-section + .notification-emails-section {
  margin-top: 12px;
}

/* Per-section recipient editor (inside each notification accordion).
   Each channel renders its own card so the four recipient blocks
   (email / slack / teams / telegram) are visually distinct. The brand
   accent color is supplied per-instance via the \`--brand-color\` CSS
   custom property set inline in the component. */
.notification-emails-section {
  margin-top: 18px;
  padding: 16px 18px 14px 18px;
  border: 1px solid #ececf2;
  border-left: 4px solid var(--brand-color, #5616ea);
  border-radius: 10px;
  background-color: #fcfcff;
}

.notification-emails-section + .notification-emails-section {
  margin-top: 12px;
}

.notification-emails-section-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 16px 0;
  font-size: 14px;
  font-weight: 600;
  color: #2b2b3a;
}

.notification-emails-section-heading-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background-color: var(--brand-bg, rgba(86, 22, 234, 0.08));
  flex-shrink: 0;
}

.notification-emails-section-heading-icon svg {
  display: block;
}

.notification-emails-section .welcome-messages-parent {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 500px;
  margin-bottom: 0px;
}

/* Base styles for the "+ add email" button, shared by NotificationCenter,
   Reporting, WidgetCustomization and WixRegister. These used to live in
   warmLeadConfig.css, which is no longer bundled after the restructure, so the
   global base was lost — restored here in an always-bundled stylesheet. */
.add-email-button {
  background-color: initial;
  border: none;
  border-radius: 10px;
  color: #5616ea;
  font-size: 26px;
  outline: none;
  padding: 0;
  text-align: left;
  transition: background-color 0.3s ease, transform 0.3s ease;
  width: 50px;
}
.add-email-button:hover {
  transform: translateY(-2px);
  cursor: pointer;
}
.add-email-button:disabled {
  color: #bbbbbb;
  transform: translateY(0px);
  cursor: not-allowed;
}

.notification-emails-section .add-email-button {
  background-color: transparent;
  border: none;
  outline: none;
  width: 50px;
  text-align: left;
  padding: 0;
  margin-top: 18px;
  color: #5616ea;
  border-radius: 10px;
  font-size: 26px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.notification-emails-section .add-email-button:hover {
  transform: translateY(-2px);
}

.notification-emails-section .add-email-button:disabled {
  color: #bbbbbb;
  transform: translateY(0px);
  cursor: not-allowed;
}

/* Red-themed variant of \`.unsaved-changes-message\`, used to surface email
   recipient validation errors above the save button. */
.notification-email-error-message {
  background-color: #fde8e8;
  border-color: #f5c2c2;
  color: #8a1f1f;
}

.notification-email-error-message .warning-text {
  color: #8a1f1f;
}

/* Inline threshold picker: it IS the usage_warning row's description line
   ("Warn at [80% v] of monthly AI responses"), so it must not add height
   beyond a normal one-line description — no extra margin, no wrapping,
   and the embedded MUI select is clamped to text-line height. */
.live-notify-usage-threshold {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.live-notify-usage-threshold .MuiInputBase-root {
  line-height: inherit;
}

/* Product updates by e-mail: one account-wide switch under the agent's matrix (ProductUpdatesSetting.js). */
.product-updates-setting {
  margin-top: 16px;
}

.notification-center-container .product-updates-head {
  margin: 0 0 12px;
  border-bottom: none;
  padding-bottom: 0;
}

.product-updates-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.product-updates-text {
  min-width: 0;
}

.product-updates-error {
  color: #d32f2f;
}
`, "",{"version":3,"sources":["webpack://./src/components/notificationCenter.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;sCACsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;gBAGgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;gCACgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,6CAA6C;EAC7C,0BAA0B;EAC1B,4DAA4D;EAC5D,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;;0CAE0C;AAC1C;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;iDAIiD;AACjD;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,kDAAkD;EAClD,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;0EAG0E;AAC1E;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,2DAA2D;EAC3D,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;uDACuD;AACvD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;gEAGgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,4GAA4G;AAC5G;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".notification-center-parent-container {\r\n  width: 100%;\r\n  max-width: 1100px;\r\n}\r\n\r\n.notification-center-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  background-color: #5616ea25;\r\n  border-radius: 10px;\r\n  padding: 15px;\r\n  padding-top: 12px;\r\n  padding-bottom: 12px;\r\n  margin-bottom: 20px;\r\n  line-height: 1.45;\r\n  border-left: 5px solid #5616ea;\r\n}\r\n\r\n.notification-center-info-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.notification-center-info-box p {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.notification-center-info-content ul {\r\n  margin: 0.5rem 0 0 0;\r\n  padding-left: 1.2rem;\r\n  list-style-type: disc;\r\n}\r\n\r\n.notification-center-info-content li {\r\n  margin-top: 7px;\r\n}\r\n\r\n.notification-center-info-icon {\r\n  font-size: 32px;\r\n  color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.notification-center-warning-inner {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  background-color: #fff9e1;\r\n  border-left: 4px solid #ffc107;\r\n  border-radius: 8px;\r\n  padding: 8px 10px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.notification-center-warning-inner p {\r\n  margin: 0;\r\n  color: #554002;\r\n  font-size: 14px;\r\n}\r\n\r\n.notification-center-warning-icon {\r\n  font-size: 20px;\r\n  color: #ffc107;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Visual indicator before each section title to make accordion sections more\r\n   distinguishable from one another. */\r\n.notification-section-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.notification-section-title-bar {\r\n  display: inline-block;\r\n  width: 4px;\r\n  height: 18px;\r\n  background-color: #5616ea;\r\n  border-radius: 2px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Apply the same purple accent bar to every accordion section header that uses\r\n   the shared `.widget-sub-header` class (Design, Human Takeover, Lead\r\n   Generation pages). Scoped to MUI AccordionSummary so non-accordion uses are\r\n   unaffected. */\r\n.MuiAccordionSummary-content .widget-sub-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.MuiAccordionSummary-content .widget-sub-header::before {\r\n  content: '';\r\n  display: inline-block;\r\n  width: 4px;\r\n  height: 18px;\r\n  background-color: #5616ea;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.notification-center-container {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n}\r\n\r\n/* Subtle inline link used in liveChatSettings & warmLeadConfig to point users\r\n   to the notification center. */\r\n.notification-center-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  align-self: flex-start;\r\n  gap: 8px;\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: #5616ea;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  text-decoration-color: rgba(86, 22, 234, 0.4);\r\n  text-underline-offset: 2px;\r\n  transition: color 0.2s ease, text-decoration-color 0.2s ease;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.notification-center-link:hover {\r\n  color: #4a14d6;\r\n  text-decoration-color: #4a14d6;\r\n}\r\n\r\n.notification-center-link-channels {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  margin-left: -2px;\r\n  color: #5616ea;\r\n  opacity: 0.75;\r\n  text-decoration: none;\r\n  font-size: 10px;\r\n}\r\n\r\n.notification-center-link:hover .notification-center-link-channels {\r\n  opacity: 1;\r\n  color: #4a14d6;\r\n}\r\n\r\n/* Recipients section — sits below the matrix. The h4 sub-header above\r\n   it provides the spacing to the matrix; the first recipient block must\r\n   therefore not add its own top margin. */\r\n.notification-recipients-block {\r\n  margin-top: 16px;\r\n}\r\n\r\n.notification-recipients-block .notification-emails-section {\r\n  margin-top: 0;\r\n}\r\n\r\n.notification-recipients-block .notification-emails-section + .notification-emails-section {\r\n  margin-top: 12px;\r\n}\r\n\r\n/* Per-section recipient editor (inside each notification accordion).\r\n   Each channel renders its own card so the four recipient blocks\r\n   (email / slack / teams / telegram) are visually distinct. The brand\r\n   accent color is supplied per-instance via the `--brand-color` CSS\r\n   custom property set inline in the component. */\r\n.notification-emails-section {\r\n  margin-top: 18px;\r\n  padding: 16px 18px 14px 18px;\r\n  border: 1px solid #ececf2;\r\n  border-left: 4px solid var(--brand-color, #5616ea);\r\n  border-radius: 10px;\r\n  background-color: #fcfcff;\r\n}\r\n\r\n.notification-emails-section + .notification-emails-section {\r\n  margin-top: 12px;\r\n}\r\n\r\n.notification-emails-section-heading {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin: 0 0 16px 0;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #2b2b3a;\r\n}\r\n\r\n.notification-emails-section-heading-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 8px;\r\n  background-color: var(--brand-bg, rgba(86, 22, 234, 0.08));\r\n  flex-shrink: 0;\r\n}\r\n\r\n.notification-emails-section-heading-icon svg {\r\n  display: block;\r\n}\r\n\r\n.notification-emails-section .welcome-messages-parent {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  max-width: 500px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n/* Base styles for the \"+ add email\" button, shared by NotificationCenter,\r\n   Reporting, WidgetCustomization and WixRegister. These used to live in\r\n   warmLeadConfig.css, which is no longer bundled after the restructure, so the\r\n   global base was lost — restored here in an always-bundled stylesheet. */\r\n.add-email-button {\r\n  background-color: initial;\r\n  border: none;\r\n  border-radius: 10px;\r\n  color: #5616ea;\r\n  font-size: 26px;\r\n  outline: none;\r\n  padding: 0;\r\n  text-align: left;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n  width: 50px;\r\n}\r\n.add-email-button:hover {\r\n  transform: translateY(-2px);\r\n  cursor: pointer;\r\n}\r\n.add-email-button:disabled {\r\n  color: #bbbbbb;\r\n  transform: translateY(0px);\r\n  cursor: not-allowed;\r\n}\r\n\r\n.notification-emails-section .add-email-button {\r\n  background-color: transparent;\r\n  border: none;\r\n  outline: none;\r\n  width: 50px;\r\n  text-align: left;\r\n  padding: 0;\r\n  margin-top: 18px;\r\n  color: #5616ea;\r\n  border-radius: 10px;\r\n  font-size: 26px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.notification-emails-section .add-email-button:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.notification-emails-section .add-email-button:disabled {\r\n  color: #bbbbbb;\r\n  transform: translateY(0px);\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Red-themed variant of `.unsaved-changes-message`, used to surface email\r\n   recipient validation errors above the save button. */\r\n.notification-email-error-message {\r\n  background-color: #fde8e8;\r\n  border-color: #f5c2c2;\r\n  color: #8a1f1f;\r\n}\r\n\r\n.notification-email-error-message .warning-text {\r\n  color: #8a1f1f;\r\n}\r\n\r\n/* Inline threshold picker: it IS the usage_warning row's description line\r\n   (\"Warn at [80% v] of monthly AI responses\"), so it must not add height\r\n   beyond a normal one-line description — no extra margin, no wrapping,\r\n   and the embedded MUI select is clamped to text-line height. */\r\n.live-notify-usage-threshold {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.live-notify-usage-threshold .MuiInputBase-root {\r\n  line-height: inherit;\r\n}\r\n\n/* Product updates by e-mail: one account-wide switch under the agent's matrix (ProductUpdatesSetting.js). */\n.product-updates-setting {\n  margin-top: 16px;\n}\n\n.notification-center-container .product-updates-head {\n  margin: 0 0 12px;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.product-updates-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.product-updates-text {\n  min-width: 0;\n}\n\n.product-updates-error {\n  color: #d32f2f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
